const ANALYTIC_CATEGORIES = {
  ACTION: 'ktor-generator-web-action',
  LINK: 'ktor-generator-web-link',
  MOVE_TO_STEP: 'ktor-generator-web-steps',
};

export default ANALYTIC_CATEGORIES;
